<template lang="pug">
  .height-100
    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="reporte_boletas")
        reporte-contratos

</template>

<script>
import ComponentReporteContratos from '../components/Component_Reporte_Contratos'
export default {
  name: 'contratos-reporte',
  components: {
    'reporte-contratos': ComponentReporteContratos
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Reporte_Contratos.vue?625f0856